import { render } from "./icon-text-block.vue?vue&type=template&id=49b8197a&ts=true"
import script from "./icon-text-block.vue?vue&type=script&lang=ts"
export * from "./icon-text-block.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__